// ID OF LAST ELEMENT 39

const jsonMainMenu = {
  isopen: true,
  role: 3,
  type: 'mainmenu',
  style: { color: '#333' },
  items: [
    {
      id: '1',
      title: 'DreamTours',
      url: '/dreamtours',
      icon: 'home',
      visible: 1,
      active: 1,
      isopen: false,
      role: 3,
      listRender: true,
      possibilityCreateFolder: true,
      items: [
        {
          id: '33',
          title: 'Denmark Folders',
          icon: '*.svg',
          url: '/dreamtours/denmark/folders',
          visible: 1,
          active: 1,
          role: 3,
          isopen: false,
          createFolder: false,
          listRender: true,
          items: [],
        },
        {
          id: '35',
          title: 'France Folders',
          icon: '*.svg',
          url: '/dreamtours/france/folders',
          visible: 1,
          active: 1,
          role: 3,
          isopen: false,
          createFolder: false,
          listRender: true,
          items: [],
        },
        {
          id: '37',
          title: 'Germany Folders',
          icon: '*.svg',
          url: '/dreamtours/germany/folders',
          visible: 1,
          active: 1,
          role: 3,
          isopen: false,
          createFolder: false,
          listRender: true,
          items: [],
        },
        {
          id: '38',
          title: 'NAF Tours',
          icon: '*.svg',
          url: '/dreamtours/naf',
          visible: 1,
          active: 1,
          role: 3,
          isopen: false,
          createFolder: false,
          listRender: true,
          items: [],
        },
      ],
    },
    {
      id: '3',
      title: 'Public Tours',
      url: '/tour',
      icon: 'tours',
      visible: 1,
      active: 1,
      isopen: false,
      role: 3,
      listRender: true,
      possibilityCreateFolder: true,
      items: [],
    },
    {
      id: '4',
      title: 'My tours',
      url: '/tour/mytour',
      icon: 'mytours',
      visible: 1,
      active: 1,
      role: 3,
      isopen: false,
      createFolder: true,
      listRender: true,
      items: [],
    },
    {
      id: '40',
      title: 'Tour main',
      url: '/tour/folders',
      icon: '*.svg',
      visible: 1,
      active: 1,
      role: 3,
      isopen: true,
      createFolder: false,
      listRender: true,
      items: [
        {
          id: '5',
          title: 'Tour folders',
          url: '/tour/folders',
          icon: '*.svg',
          visible: 1,
          active: 1,
          role: 3,
          isopen: false,
          createFolder: false,
          listRender: true,
          items: [],
        },
      ],
    },

    {
      id: '6',
      title: 'Friend tours',
      icon: 'friendtours',
      url: '/tour/friendtour',
      visible: 1,
      active: 1,
      role: 3,
      isopen: false,
      listRender: true,
      items: [],
    },
    {
      id: '7',
      title: 'selectFriend',
      icon: '*.svg',
      url: '#',
      visible: 0,
      active: 1,
      role: 3,
      isopen: false,
      listRender: true,
      items: [],
    },
    {
      id: '8',
      title: 'Places',
      url: '/place',
      icon: 'places',
      visible: 1,
      active: 1,
      isopen: false,
      role: 3,
      listRender: true,
      possibilityCreateFolder: true,
      items: [
        {
          id: '9',
          title: 'Public',
          icon: '*.svg',
          url: '/place',
          visible: 1,
          active: 1,
          role: 3,
          isopen: false,
          createFolder: false,
          listRender: true,
          items: [],
        },
        {
          id: '10',
          title: 'My Places',
          icon: '*.svg',
          url: '/place/my',
          visible: 1,
          active: 1,
          role: 3,
          isopen: false,
          createFolder: true,
          listRender: true,
          items: [],
        },
        {
          id: '11',
          title: 'Place folders',
          url: '/place/folders',
          icon: '*.svg',
          visible: 1,
          active: 1,
          role: 3,
          isopen: false,
          createFolder: false,
          listRender: true,
          items: [],
        },
        {
          id: '12',
          title: 'Create a Place',
          icon: '*.svg',
          url: '/place/create',
          visible: 1,
          active: 1,
          role: 3,
          isopen: false,
          items: [],
        },
      ],
    },
    {
      id: '13',
      title: 'Track',
      icon: 'track',
      url: '/track',
      visible: 1,
      active: 1,
      role: 3,
      isopen: false,
      listRender: true,
      items: [],
    },
    {
      id: '14',
      title: 'Bike Club',
      url: '/club',
      icon: 'bikerclub',
      visible: 1,
      active: 1,
      isopen: false,
      role: 3,
      possibilityCreateFolder: false,
      listRender: true,
      items: [
        {
          id: '15',
          title: 'All',
          url: '/club',
          icon: '*.svg',
          visible: 1,
          active: 1,
          role: 3,
          isopen: false,
          createFolder: false,
          listRender: true,
          items: [],
        },
        {
          id: '16',
          title: 'NAF MC Clubs',
          url: '/club/naf',
          icon: '*.svg',
          visible: 1,
          active: 1,
          role: 3,
          isopen: false,
          createFolder: false,
          listRender: true,
          items: [],
        },
        {
          id: '17',
          title: 'My Bike Clubs',
          url: '/club/my',
          icon: '*.svg',
          visible: 1,
          active: 1,
          role: 3,
          isopen: false,
          createFolder: false,
          listRender: true,
          items: [],
        },
        {
          id: '18',
          title: 'Create a Bike Club',
          url: '/club/create',
          icon: '*.svg',
          visible: 1,
          active: 1,
          role: 3,
          isopen: false,
          items: [],
        },
      ],
    },
    {
      id: '19',
      title: 'BikerBed',
      url: '/bikerbed',
      icon: 'bikerbed',
      visible: 1,
      active: 1,
      isopen: false,
      role: 3,
      listRender: true,
      possibilityCreateFolder: false,
      items: [
        {
          id: '20',
          title: 'All',
          url: '/bikerbed',
          icon: '*.svg',
          visible: 1,
          active: 1,
          role: 3,
          isopen: false,
          createFolder: false,
          listRender: true,
          items: [],
        },
        {
          id: '21',
          title: 'My BikerBeds',
          url: '/bikerbed/my',
          icon: '*.svg',
          visible: 1,
          active: 1,
          role: 3,
          isopen: false,
          createFolder: false,
          listRender: true,
          items: [],
        },
        {
          id: '22',
          title: 'Create a BikerBed',
          url: '/bikerbed/create',
          icon: '*.svg',
          visible: 1,
          active: 1,
          role: 3,
          isopen: false,
          items: [],
        },
      ],
    },
    {
      id: '23',
      title: 'Members',
      url: '/members',
      icon: 'members',
      visible: 1,
      active: 1,
      role: 3,
      isopen: false,
      listRender: false,
      items: [],
    },
    {
      id: '24',
      title: 'Tourstart PRO',
      url: '/pro',
      icon: 'pro',
      visible: 1,
      active: 1,
      role: 3,
      isopen: false,
      items: [],
    },
    {
      id: '25',
      title: 'Tourstart Academy',
      url: '?scope=academy',
      icon: 'academy',
      visible: 1,
      active: 1,
      role: 3,
      isopen: false,
      items: [],
    },
    {
      id: '26',
      title: 'More',
      url: '#more',
      icon: 'more',
      visible: 1,
      active: 1,
      isopen: false,
      role: 3,
      items: [
        {
          id: '27',
          title: 'Help',
          url: '/faq',
          icon: '*.svg',
          visible: 1,
          active: 1,
          role: 3,
          isopen: false,
          items: [],
        },
        {
          id: '28',
          title: 'Legal issues',
          url: '/legalissues',
          icon: '*.svg',
          visible: 1,
          active: 1,
          role: 3,
          isopen: false,
          items: [],
        },
        {
          id: '29',
          title: 'About Tourstart',
          url: '/about',
          icon: '*.svg',
          visible: 1,
          active: 1,
          role: 3,
          isopen: false,
          items: [],
        },
        {
          id: '30',
          title: 'Statement',
          url: '/statement',
          icon: '*.svg',
          visible: 1,
          active: 1,
          role: 3,
          isopen: false,
          items: [],
        },
        {
          id: '31',
          title: 'Contact',
          url: '/contact',
          icon: '*.svg',
          visible: 1,
          active: 1,
          role: 3,
          isopen: false,
          items: [],
        },
      ],
    },
  ],
};

export default jsonMainMenu;
